module.exports = __webpack_public_path__ + "img/server-primary.72cf6a74.svg";